import { Outlet } from "react-router-dom";
import Header from "../../components/pajuspiel/Header";
import Footer from "../../components/Footer";
import { COLORS } from "./styles";

export default function Layout() {
  return (
    <div className={`App min-h-screen w-full ${COLORS.BACKGROUND}`}>
      <div className="flex-1 flex flex-col w-full md:p-6 py-4">
        <Header />
        <main className="flex-1 w-full">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
